import TextInput from "components/form/input/TextInput";
import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields";
import ADF from "..";

export function AFCParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={ADF.field + tipoIndicadorField}
            bottomFields={
                <>
                    <ParamFormRow label="Intervalo de Aderência">
                        <TextInput name="mecanizado.intervaloMin" label="Mínimo" type="number" />
                        <TextInput name="mecanizado.intervaloMax" label="Máximo" type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Metros Lineares por Amostra">
                        <TextInput name="mecanizado.metrosLinearesAmostra" label="Valor (Metros)" type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Metros Lineares por Hectare">
                        <TextInput name="mecanizado.metrosLinearesHectare" label="Valor (Metros)" type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Meta">
                        <TextInput name="mecanizado.meta" label="Meta (%)" type="number" />
                    </ParamFormRow>
                </>
            }
        />
    );
}
